import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { StationsAdvancedFilter } from '../StationsAdvancedFilter';
import { MinimumStationsGroup, Station } from '@app/core/types/stations';

export type StationsAdvancedFilterFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
  /** Use `small` for 40px height to match other MUI small inputs. */
  size?: 'small' | 'medium';
  stations?: readonly Station[];
  stationGroups?: MinimumStationsGroup[];
  disabled?: boolean;
};

export function StationsAdvancedFilterField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  label,
  placeholder,
  multiple = true,
  size,
  stations,
  stationGroups,
  disabled,
}: StationsAdvancedFilterFieldProps<TFieldValues, TName>): JSX.Element {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <StationsAdvancedFilter
          stations={stations || []}
          stationGroups={stationGroups || []}
          value={field.value || []}
          onChange={(selectedOptions) => {
            field.onChange(selectedOptions);
          }}
          multiple={multiple}
          size={size}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
}
